import styled from 'styled-components';

const Content = styled.div`
  position: relative;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: 180px 1fr;
  column-gap: 1.5rem;
  padding-right: 4rem;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    padding-right: 1.5rem;
  }
`;

export default { Content, Grid };
